<div class="modal inmodal fade in show">
    <form #form="ngForm" autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">{{title}}</h4>
                </div>

                <div class="modal-body detailed-view-body">
                    <div class="row m-b-sm step-guide">
                        <div (click)="moveToTheNextStep('details')" class="mtv-primary-color">
                            <span>User Details</span>
                        </div>
                        <div (click)="moveToTheNextStep('roles')"
                             *ngIf="itemData.userType == 'property_manager'"
                             [ngClass]="{'mtv-primary-color' : (step == 'roles' || step == 'summary')}">
                            <span>User Roles</span>
                        </div>
                        <div (click)="moveToTheNextStep('summary')"
                             [ngClass]="{'mtv-primary-color' : step == 'summary'}">
                            <span>Summary</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar">
                        <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>

                    <div *ngIf="step == 'details'">
                        <div class="row m-b-sm">
                            <div class="dv-label col-md-3">
                                <label>Full Name</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="fullName" [(ngModel)]="itemData.fullName" required>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="dv-label col-md-3">
                                <label>Company</label>
                            </div>
                            <div class="col-md-9">
                                <select class="form-control"
                                        name="company"
                                        [(ngModel)]="itemData.company.id">
                                    <option *ngFor="let c of userService.companies" [value]="c.id">{{c.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!isSuperAdmin">
                            <div class="dv-label col-md-3">
                                <label>Phones</label>
                            </div>
                            <div class="col-md-9">
                                <phone-field #phoneField
                                             [ngModel]="itemData.phones"
                                             name="phones"
                                             [title]="''"
                                             [userId]="itemData.id"
                                             [editOnly]="true"
                                             [inModalStyling]="true"
                                             [hideEmptyArrayLabel]="true"
                                             (reset)="resetPhones($event)">
                                </phone-field>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="dv-label col-md-3">
                                <label>Email</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="email" [(ngModel)]="itemData.email" required>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="modalType !== 'edit'">
                            <div class="dv-label col-md-3"></div>
                            <div class="col-md-9">
                                <label class="img-checkbox m-b-n">
                                    <input type="checkbox"
                                           id="sendInvitationEmail"
                                           name="sendInvitationEmail"
                                           [(ngModel)]="itemData.sendInvitationEmail">
                                    <label for="sendInvitationEmail"><svg-checked></svg-checked></label>
                                    <span>Send invitation email</span>
                                </label>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="isSuperAdmin">
                            <div class="dv-label col-md-3">
                                <label>Phones</label>
                            </div>
                            <div class="col-md-9">
                                <phone-field #phoneField
                                             [ngModel]="itemData.phones"
                                             name="phones"
                                             [title]="''"
                                             [userId]="itemData.id"
                                             [editOnly]="true"
                                             [inModalStyling]="true"
                                             [hideEmptyArrayLabel]="true"
                                             (reset)="resetPhones($event)">
                                </phone-field>
                            </div>
                        </div>

                        <div *ngIf="isSuperAdmin" class="row m-b-sm">
                            <div class="dv-label col-md-3">
                                <label>User Type</label>
                            </div>
                            <div class="col-md-9">
                                <select class="form-control" name="userType" [(ngModel)]="itemData.userType">
                                    <option *ngFor="let t of userTypes" [value]="t.id">{{t.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row text-center m-t-lg">
                            <button class="btn btn-primary submit-btn" type="submit"
                                    [disabled]="isContinueButtonDisabled('details')"
                                    (click)="moveToTheNextStep(itemData.userType == 'property_manager' ? 'roles' : 'summary')">
                                Continue
                            </button>
                        </div>
                    </div>
                    <div *ngIf="step == 'roles' && itemData.userType == 'property_manager'">
                        <div *ngIf="itemData.userType !== 'super_admin'" class="user-roles-box">
                            <div class="row m-b-sm">
                                <div class="dv-label col-md-3">
                                    <label>Corporation #</label>
                                </div>
                                <div class="col-md-9">
                                    <search-select [ngModel]="userRolesList[0].corporationNumberId"
                                                   class="user-roles-select"
                                                   [noPadding]="true"
                                                   [ngModelOptions]="{standalone: true}"
                                                   (ngModelChange)="onCorporationSelect($event, 0)"
                                                   [data]="userService.corporationNumberListForSearchSelect">
                                    </search-select>
                                </div>
                            </div>
                            <div class="row m-b-sm">
                                <div class="dv-label col-md-3">
                                    <label>User Role</label>
                                </div>
                                <div class="col-md-9">
                                    <select-field [ngModelOptions]="{standalone: true}"
                                                  [ngModel]="userRolesList[0].role"
                                                  [data]="userRolesList[0].userRoles"
                                                  [editOnly]="true"
                                                  (change)="onRoleSelect($event, 0)">
                                    </select-field>
                                </div>
                            </div>
                            <div class="row m-b-sm">
                                <div class="dv-label col-md-3">
                                    <label>Buildings</label>
                                </div>
                                <div class="col-md-9">
                                    <angular2-multiselect [ngModelOptions]="{standalone: true}"
                                                          [data]="userRolesList[0].multiselectBuildings"
                                                          [(ngModel)]="userRolesList[0].properties"
                                                          (onSelect)="onSelect($event)"
                                                          (onDeSelect)="onDeselect($event)"
                                                          (onSelectAll)="onSelectAll($event, 0)"
                                                          (onDeSelectAll)="onDeselectAll($event, 0)"
                                                          [settings]="multiselectSettings">
                                    </angular2-multiselect>
                                </div>
                            </div>
                            <div class="m-b-sm">
                                <button type="button"
                                        class="add-new-role-btn mtv-primary-color"
                                        (click)="addNewRole()"
                                        [disabled]="addNewRoleDisabled()">
                                    + Add Role
                                </button>
                            </div>
                            <table class="user-role-table" *ngIf="userRolesList.length > 1">
                                <tr>
                                    <th>Corporation #</th>
                                    <th>User Role</th>
                                    <th>Buildings</th>
                                    <th></th>
                                </tr>
                                <tr *ngFor="let item of userRolesList | slice:1; let index = index;">
                                    <td>
                                        <div>{{item.corporationName}}</div>
                                    </td>
                                    <td>
                                        <div>{{item.roleName}}</div>
                                    </td>
                                    <td>
                                        <div *ngFor="let i of item.properties">
                                            {{i.name || i.itemName}}
                                        </div>
                                    </td>
                                    <td>
                                        <i *ngIf="userRolesList.length > 1"
                                           class="fa fa-trash pull-right"
                                           (click)="remove(index + 1)">
                                        </i>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div class="row text-center m-t-lg">
                            <button class="btn btn-primary submit-btn" type="submit"
                                    [disabled]="isContinueButtonDisabled('roles')"
                                    (click)="moveToTheNextStep('summary')">
                                Continue
                            </button>
                        </div>
                    </div>
                    <div *ngIf="step == 'summary'">
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Full Name</label>
                            </div>
                            <div class="col-md-9">
                                {{itemData.fullName}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Company</label>
                            </div>
                            <div class="col-md-9">
                                {{getCompanyById(itemData.company.id)}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="itemData.phones.length > 0">
                            <div class="dv-label col-md-3">
                                <label>Phones</label>
                            </div>
                            <div class="col-md-9">
                                <phone-field #phoneField
                                             [ngModel]="itemData.phones"
                                             name="phones"
                                             [title]="''"
                                             [userId]="itemData.id"
                                             [noEdit]="true"
                                             [inModalStyling]="true"
                                             [hideEmptyArrayLabel]="true"
                                             (reset)="resetPhones($event)">
                                </phone-field>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Email</label>
                            </div>
                            <div class="col-md-9">
                                {{itemData.email}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Invitation Email</label>
                            </div>
                            <div class="col-md-9">
                                {{itemData.sendInvitationEmail ? 'Yes' : 'No'}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>User Type</label>
                            </div>
                            <div class="col-md-9">
                                {{getUserTypeById(itemData.userType)}}
                            </div>
                        </div>

                        <div class="row text-center m-t-lg">
                            <button class="btn btn-primary submit-btn"
                                    type="submit"
                                    (click)="onSubmit(form)"
                                    [disabled]="disabledSubmit">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal-backdrop fade in" (click)="close()"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/modal/modal.component.html